import { render, staticRenderFns } from "./RecallContextMenu.vue?vue&type=template&id=56054a03&"
import script from "./RecallContextMenu.vue?vue&type=script&lang=js&"
export * from "./RecallContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports